
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  color:var(--sic-heading-color);
  font-family:var(--ff-display);
  display:block;
}

.eyebrow,
.eyebrow :is(h1, h2, h3, h4, h5, h6, h7){
  letter-spacing:0.5px;
  font-weight:normal !important;
  font-size:var(--headline-eyebrow-font-size);
}

.subtitle-wrapper{
  font-weight:normal;
}
`;